import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "Финансирование",
  "lead": "Каждая третья страна не достигла ни одного из финансовых контрольных показателей, установленных в Рамочной программе действий «Образование-2030»."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, HighlightByPalette, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!HighlightByPalette) _missingMdxReference("HighlightByPalette", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_FINANCE"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "Амбициозные задачи ЦУР в области образования не будут достигнуты без дополнительных ресурсов, особенно в странах, которые отстают больше всего."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "В докладе ВДМО было подсчитано, что для достижения цели всеобщего базового образования к 2030 году, т. е. дошкольного, начального и среднего образования, странам с низким уровнем доходов и с уровнем доходов ниже среднего необходимо ежегодно тратить на образование 461 млрд долл. США. Многие страны вряд ли смогут в достаточной степени увеличить бюджеты из-за низких налоговых поступлений, что приведет к предполагаемому годовому дефициту финансирования в размере 97 млрд долл. США (21 % от общей суммы) для достижения национальных целей в период с 2023 по 2030 год. Средний разрыв составляет 26 млрд долл. США (50 % от общей суммы) в странах с низким уровнем дохода и 71 млрд долл. США (17 %) в странах с уровнем дохода ниже среднего, что эквивалентно 2,3 % от ВВП за соответствующий период."
    }), "\n", _jsx(IndicatorReference, {
      id: "4.5.3",
      children: _jsxs(_components.p, {
        children: ["При этом наличие большего количества ресурсов необязательно является достаточным; страны, тратящие одинаковую сумму с точки зрения дохода на душу населения, могут иметь совершенно разные результаты в сфере образования в зависимости от того, насколько эффективно, результативно и справедливо они расходуют средства. Например, из 78 стран с низким и средним уровнем дохода, располагающих доступной информацией, только 17 — или каждая пятая — сохранили сильный ", _jsx(_components.a, {
          href: "https://www.unesco.org/gem-report/en/node/80",
          children: "акцент на справедливости посредством финансовой политики"
        }), ". В основном это страны с уровнем дохода выше среднего и страны Латинской Америки."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Тремя основными источниками расходов на образование являются правительства, домохозяйства и доноры. На этой странице основное внимание будет уделено первым двум. Отдельная страница посвящена ", _jsx(_components.a, {
        href: "https://www.education-progress.org/en/articles/finance-aid",
        children: "помощи на образование"
      }), "."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TOTBYSOURCE"
        })
      }), _jsx(ScrollySection, {
        id: "absolute,0",
        children: _jsx(_components.p, {
          children: "В 2022 году из 5,8 трлн долл. США, потраченных на образование во всем мире, только 0,45 % было израсходовано в странах с низким уровнем дохода, в то время как 64 % было израсходовано в странах с высоким уровнем дохода, хотя в этих двух группах примерно одинаковое количество детей школьного возраста."
        })
      }), _jsx(ScrollySection, {
        id: "relative,1",
        children: _jsxs(_components.p, {
          children: ["В среднестатистической стране ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "1",
            children: "домохозяйства"
          }), " покрывают четверть стоимости образования. Фактически домохозяйства несут гораздо большие расходы на образование в странах с уровнем дохода ниже среднего (44 %), чем в странах с высоким уровнем дохода (20 %)."]
        })
      }), _jsx(ScrollySection, {
        id: "relative,2",
        children: _jsxs(_components.p, {
          children: ["Несмотря на то что ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "доноры"
          }), " покрывают 12 % от общего объема расходов на образование в странах с низким уровнем дохода…"]
        })
      }), _jsx(ScrollySection, {
        id: "absolute,3",
        children: _jsxs(_components.p, {
          children: ["… вклад", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "доноров"
          }), " составляет всего 0,3 % от общего объема расходов во всем мире, что едва заметно в абсолютных суммах."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "государственные-расходы",
      children: "Государственные расходы"
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.1",
      children: [_jsxs(_components.p, {
        children: [_jsx(_components.a, {
          href: "https://unesdoc.unesco.org/ark:/48223/pf0000245656",
          children: "Рамочная программа действий «Образование-2030»"
        }), " установила два ключевых финансовых контрольных показателя для правительств. Она призывает:"]
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "выделять на образование не менее 4–6 % от ВВП, и (или)"
        }), "\n", _jsx(_components.li, {
          children: "выделять на образование не менее 15–20 % государственных расходов."
        }), "\n"]
      }), _jsx(_components.p, {
        children: "Во всем мире правительства не сильно отклонились от этих норм. Средние государственные расходы составляют 4 % от ВВП и 12,6 % от общих государственных расходов. Правительства в более бедных странах с низким потенциалом генерирования внутренних ресурсов, но с большим количеством детей, как правило, тратят на образование меньше в процентах от ВВП, но больше в процентах от общих государственных расходов."
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.2",
      children: [_jsx(_components.p, {
        children: "В странах Африки к югу от Сахары государственные расходы на образование составляют 15,5 % от общего объема государственных расходов, однако это составляет всего 3,5 % от ВВП. И наоборот, Европа и Северная Америка соответствуют контрольному показателю в том, что касается доли ВВП (4,8 %), но выделяют низкую долю общих расходов на образование (10,9 %)."
      }), _jsx(_components.p, {
        children: "Однако в целом примерно каждая третья страна, по которой имеются последние данные, не достигла ни одного из контрольных показателей. Просмотрите эти данные с течением времени, чтобы увидеть, как меняются расходы на протяжении многих лет."
      })]
    }), "\n", _jsx(Figure, {
      id: "GOVVGDP"
    }), "\n", _jsx(_components.p, {
      children: "Основным источником доходов правительства является налогообложение, даже в странах с низким уровнем дохода, получающих большую долю доходов от грантов (т. е. помощи). В целом средние налоговые поступления в виде доли ВВП составили 14 % в странах с низким уровнем дохода, 18 % в странах с уровнем дохода ниже среднего, 22 % в странах с уровнем дохода выше среднего и 33 % в странах с высоким уровнем дохода. Например, даже если бы все страны отдали образованию одинаковый приоритет в своих бюджетах, страны, которые собирают больше налогов и других внутренних ресурсов, будут тратить больше на образование."
    }), "\n", _jsx(_components.p, {
      children: "При этом большая разница в суммах, расходуемых на образование в странах со схожими характеристиками, свидетельствует о том, что в этих отношениях нет ничего предопределенного. Некоторые страны предпочитают тратить больше средств на образование для достижения своих целей. И нам следует обратить внимание на те страны, кто этого не делают."
    }), "\n", _jsx(_components.h2, {
      id: "расходы-домохозяйств",
      children: "Расходы домохозяйств"
    }), "\n", _jsx(_components.p, {
      children: "Домохозяйства тратят значительные суммы на поддержку образования своих детей, причем в бедных странах эти расходы выше, чем в богатых."
    }), "\n", _jsx(_components.p, {
      children: "Эти расходы могут быть выражены в форме платы за обучение и других сборов, а также расходов на образовательные товары и услуги. Некоторые из них являются обязательными (например, учебники), а другие — нет (например, частные уроки)."
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.4",
      children: [_jsx(_components.p, {
        children: "Если стандартизировать имеющиеся данные по странам, можно получить впечатляющие доказательства вклада домохозяйств в общие расходы на образование. Это может изменить восприятие усилий стран в сфере образования."
      }), _jsx(_components.p, {
        children: "В странах с низким уровнем дохода домохозяйства тратят на образование менее 1 % своего бюджета из-за экономических трудностей. Напротив, в странах с уровнем дохода ниже среднего медианная доля расходов на образование в бюджете домохозяйств составляет 2,9 %, а невзвешенное среднее значение — 3,6 %, при этом распределение их расходов является самым широким среди всех групп по уровню дохода. Высокий уровень расходов в странах с уровнем дохода ниже среднего свидетельствует о том, что домохозяйства сталкиваются с необходимостью восполнять недостаточное государственное финансирование. В странах с уровнем дохода выше среднего медианная доля расходов на образование в бюджете домохозяйств составляет всего 1,5 %, а невзвешенное среднее значение — 2,3 %. Наконец, в странах с высоким уровнем дохода медианная доля расходов на образование в бюджете домохозяйств составляет 1,3 %, а невзвешенное среднее значение — 1,7 %."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GOVHH_ABS_REL"
          })
        }), _jsx(ScrollySection, {
          id: "absolute,BGD,FRA",
          children: _jsxs(_components.p, {
            children: ["Например, в 2019 году ", _jsx(_components.strong, {
              children: "Бангладеш"
            }), " имел один из самых низких уровней ", _jsx(HighlightByIndex, {
              index: "0",
              children: "государственных расходов"
            }), " в процентах от ВВП. Тем не менее, если принять во внимание ", _jsx(HighlightByIndex, {
              index: "1",
              children: "вклад домохозяйств,"
            }), " общие национальные расходы Бангладеш на образование в процентах от ВВП будут аналогичны расходам ", _jsx(_components.strong, {
              children: "Франции"
            }), "."]
          })
        }), _jsx(ScrollySection, {
          id: "absolute,IND,BEL",
          children: _jsxs(_components.p, {
            children: ["Правительство ", _jsx(_components.strong, {
              children: "Индии"
            }), " потратило на образование примерно на 2,4 ", _jsx(HighlightByIndex, {
              index: "0",
              children: "процентных пункта ВВП"
            }), " меньше, чем ", _jsx(_components.strong, {
              children: "Бельгия"
            }), " (синяя полоса), однако Индия потратила в целом больше, чем Бельгия, потому что ее ", _jsx(HighlightByIndex, {
              index: "1",
              children: "домохозяйства"
            }), " потратили более 2,6 процентных пункта ВВП на образование (красная полоса)."]
          })
        }), _jsx(ScrollySection, {
          id: "relative,NGA,LBN,HTI",
          children: _jsxs(_components.p, {
            children: [_jsx(HighlightByIndex, {
              index: "1",
              children: "Доля домохозяйств"
            }), " в общих расходах на образование в некоторых странах, включая ", _jsx(_components.strong, {
              children: "Нигерию"
            }), ", ", _jsx(_components.strong, {
              children: "Гаити"
            }), " и ", _jsx(_components.strong, {
              children: "Ливан"
            }), ", превышает 70 %."]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "заключение",
      children: "Заключение"
    }), "\n", _jsx(_components.p, {
      children: "Группа по подготовке Всемирного доклада по мониторингу образования уже давно утверждает, что для понимания глобальных расходов на образование необходимо совместное изучение трех основных источников финансирования образования: внутреннего государственного финансирования, внешнего государственного финансирования и частного финансирования. Поэтому существует потребность в своевременных и последовательных данных из стран с низким и средним уровнем дохода о том, сколько средств тратится на образование и из каких источников."
    }), "\n", _jsx(_components.p, {
      children: "Помимо увеличения финансирования образования, нам также необходимо укрепить справедливое распределение средств. Для достижения глобальной цели в области образования, ЦУР 4, важно, чтобы страны и доноры взяли на себя ответственность и выполнили свои обязательства."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://www.unesco.org/gem-report/en/2024efw",
            children: "Обзор финансирования образования за 2024 год"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/financing-for-equity",
            children: "Разблокирование финансирования для обеспечения равенства в образовании"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://education-profiles.org/",
            children: "Досье для подготовки обзоров о национальных системах образования (PEER)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/node/3141",
            children: "COVID-19 серьезно препятствует оказанию помощи на восстановление систем образования"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
